const FACEBOOK_PATTERNS = [
  /^https?:\/\/(?:(?:www|m)\.)?facebook\.com\/watch\?v=[\w-]+/,
  /^https?:\/\/(?:(?:www|m)\.)?facebook\.com\/share\/v\/[\w-]+\/?/,
  /^https?:\/\/(?:(?:www|m)\.)?facebook\.com\/share\/r\/[\w-]+\/?/,
  /^https?:\/\/fb\.watch\/[\w-]+/,
  /^https?:\/\/(?:(?:www|m)\.)?facebook\.com\/[^/]+\/videos\/[\w-]+/,
  /^https?:\/\/(?:(?:www|m)\.)?facebook\.com\/groups\/[^/]+\/posts\/[\w-]+/,
  /^https?:\/\/(?:(?:www|m)\.)?facebook\.com\/ads\/library\/\?id=[\d]+/,
]

const YOUTUBE_PATTERNS = [
  /^https?:\/\/(?:(?:www|m|music)\.)?youtube\.com\/watch\?v=[\w-]+/,
  /^https?:\/\/(?:(?:www|m|music)\.)?youtube\.com\/shorts\/[\w-]+/,
  /^https?:\/\/youtu\.be\/[\w-]+/,
  /^https?:\/\/(?:(?:www|m|music)\.)?youtube\.com\/embed\/[\w-]+/,
  /^https?:\/\/(?:(?:www|m|music)\.)?youtube\.com\/v\/[\w-]+/,
]

const TIKTOK_PATTERNS = [
  /^https?:\/\/(?:www\.)?tiktok\.com\/@[\w.-]+\/video\/\d+/,
  /^https?:\/\/(?:www\.)?tiktok\.com\/t\/[\w-]+/,
  /^https?:\/\/(?:vm|vt)\.tiktok\.com\/[\w-]+/,
  /^https?:\/\/(?:www\.)?tiktok\.com\/video\/\d+/,
]

const VIDEO_PATTERNS = [...FACEBOOK_PATTERNS, ...YOUTUBE_PATTERNS, ...TIKTOK_PATTERNS]

export function isValidVideoUrl(url: string): boolean {
  if (!url || !url.startsWith('http')) return false
  return VIDEO_PATTERNS.some((pattern) => pattern.test(url))
}
